import type { ApiAudienceListJSON } from '@/mastodon/api_types/audience_lists';
import { createAppSelector } from '@/mastodon/store/typed_functions';

const isDefined = (
  audienceList: ApiAudienceListJSON | undefined,
): audienceList is ApiAudienceListJSON => !!audienceList;

export const selectAudienceList = createAppSelector(
  [(state) => state.audienceLists.audienceLists, (_state, id: string) => id],
  (audienceLists, id) => audienceLists[id],
);

export const selectMyAudienceLists = createAppSelector(
  [
    (state) => state.audienceLists.audienceLists,
    (state) => state.audienceLists.myAudienceLists,
  ],
  (audienceLists, query) =>
    query.ids.map((id) => audienceLists[id]).filter(isDefined),
);
